// extracted by mini-css-extract-plugin
export default {"mainHeader":"MainHeader_mainHeader__UclwB","mainHeader__innerCont":"MainHeader_mainHeader__innerCont__LiFnr"};